import Vue from 'vue'
import Buefy from 'buefy'
import '@/assets/sass/main.sass'

Vue.use(Buefy)
